<template>
	<div class="member-list-row"
		v-bind:class="classMemberListRow"
	>
		<div class="member-list-row-inner" v-bind:style="styleInner">
			<div class="member-list-row-content d-flex pa-2">
				<div style="width: 100%;">
					<div class="name">{{ this.item.name }}</div>
					<div class="tel">連絡先: {{ this.item.tel }}</div>
					<GBClasses
						:items="this.item.classes"
						:max_width=278
						:all_show=false
					/>
				</div>
			</div>
			<div class="member-list-row-action-cancel" v-if="isRowMove && isSelected">
				<v-btn fab flat class="btn-end-row-move" v-on:click="onClickRowMoveEnd">
					<v-icon>close</v-icon>
				</v-btn>
			</div>
			<div class="member-list-row-action d-flex" v-if="!isRowMove">
				<v-btn fab flat class="btn-slide" v-on:click.stop="toggleSlideLeft"><v-icon>more_horiz</v-icon></v-btn>
				<v-icon class="alert-icon" v-if="alert">error</v-icon>
			</div>
			<div class="member-list-row-right d-flex" v-if="!isRowMove">
				<template v-if="isEditable">
					<v-btn depressed color="info" v-on:click.stop="onClickRowMoveStart">
						<v-icon>swap_vert</v-icon>
					</v-btn>
					<v-btn depressed color="warning" class="btn-edit" v-on:click.stop="onShowEditMemberInfo">編集</v-btn>
				</template>
				<template v-else>
					<v-btn depressed color="info" class="btn-show" v-on:click.stop="onShowReferenceMemberInfo">参照</v-btn>
				</template>
			</div>
		</div>
	</div>
</template>
<script>
import {SLIDE, FORM_MODE} from '../data/Const';
import GBClasses from './GBClasses';

export default {
	name: 'GBMemberListRow',
	props: [
		"item",
		"alert",
		"isEditable",
		"watchSlide",
		"isSelected",
		"PositionFirst",
		"isRowMove",
		'isSpliced'
	],
	components: {
		GBClasses,
	},
	data: function() {
		return {
			is_selected:false,
			slide_status: SLIDE.STATUS.CENTER,
		};
	},
	methods: {
		toggleSlide: function(direction) {
			if (this.slide_status === direction)
				this.slide_status = SLIDE.STATUS.CENTER;
			else {
				this.slide_status = direction;
				this.$emit('schedule-list-row-slide', {target: this.item, status: this.slide_status});
			}
		},
		toggleSlideLeft: function() {
			this.toggleSlide(SLIDE.STATUS.LEFT);
		},
		onShowEditMemberInfo: function() {
			let target = {member: this.item, mode: FORM_MODE.EDIT};
			this.$emit("show-member-info", target);
			this.toggleSlideLeft();
		},
		onShowReferenceMemberInfo: function() {
			let target = {member: this.item, mode: FORM_MODE.REFERENCE};
			this.$emit("show-member-info", target);
			this.toggleSlideLeft();
		},
		onClickRowMoveEnd: function() {
			this.$emit('member-row-move-end');
		},
		onClickRowMoveStart: function(){
			this.$emit('member-row-move-start', this);
			this.toggleSlideLeft();
		},
	},
	computed: {
		styleInner: function() {
			let left = 0;
			if (this.slide_status == SLIDE.STATUS.LEFT) {
				if (!this.isEditable){
					left =  -60;
				}else{
					left =  -120;
				}
			}
			return {
				left: left + 'px',
				transition: 'all .3s ease-in',
			};
		},
		classMemberListRow: function() {
			let classes = new Array();
			if ( this.isEditable ){
				classes.push("selectable-row");
			}
			if ( this.isSelected ){			
				classes.push("selected");
			}
			if ( this.isSpliced ){
				classes.push("splice");
			}
			return classes;
		},
	},
	watch: {
		isEditable: function() {
			this.slide_status = SLIDE.STATUS.CENTER;

		},
		item: function() {
			this.slide_status = SLIDE.STATUS.CENTER;
		},
		watchSlide: function(value) {
			if (value.type === 'slide' && value.target === this.item)
				return;
			if (this.slide_status !== SLIDE.STATUS.CENTER)
				this.slide_status = SLIDE.STATUS.CENTER;
		},
	},
};
</script>
<style>
	.member-list-row {
		position: relative;
		flex: 1 1 auto;
		overflow: hidden;
		width: 100%;
		height: 84px;
		background-color: #fefefe;
		border-bottom: solid 1px #a9a9a9;
	}
	.member-list-row-inner {
		display: flex;
		position: relative;
		width: 470px;
	}
	.member-list-row-content {
		padding: .25em;
		width: 294px;
	}
	.member-list-row-content .name {
		height: 1.5em;
		word-wrap: normal;
		overflow: hidden;
	}
	.member-list-row-action {
		position: relative;
	}
	.member-list-row-action .btn-slide {
		min-width: 36px !important;
	}
	.member-list-row-right div {
		width: 16px;
	}
	.member-list-row .name {
		font-size: 18px;
	}
	.member-list-row .tel {
		font-size: 14px;
	}
	.btn-end-row-move{
		text-align:left;
	}
</style>
<style scoped>
	.v-btn {
		margin: 0;
		padding: 0;
		min-width: 60px;
		height: 100%;
		border-radius: 0;
		font-size: .75em;
	}
	
	.btn-end-row-move{
		width: 45px !important;
		font-size: .5rem !important;
		min-width: 0 !important;
	}
	
	.alert-icon {
		position: absolute;
		right: 15px;
		top: 0;
		opacity: .6;
		cursor: pointer;
		pointer-events: none;
		color: darkorange;
	}

	.selected{
		box-shadow: -3px 3px 5px;
		z-index: 2;
		position: relative;
		background-color: lightcyan;
		left: 5px;
		top: -5px;
	}
	
	.selected.splice{
		box-shadow: 0px 0px 0px !important;
		transition: 1.8s;
		background-color: white !important;
		position: static !important;
		left: 0px !important;
		top: 0px !important;
	}

</style>
